import React from "react";
import { Route, Switch } from "react-router-dom";
import Tarrif from "../../Tarrif/Tarrif";

import { SiteLayout } from "./Components/SiteLayout";

function LeftDrawer() {
  return <SiteLayout />;
}

export { LeftDrawer };
